import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminPartnersApi as r } from "@maat/api-main";
//#region src/partners/admin/useCreatePartnerMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.create(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreatePartnerMutation };
